import { apiFetch } from '@/shared/api/apiFetch';
import {
  employeeListResponseSchema,
  employeeProfileResponseSchema,
  type EmployeeListResponse,
  type EmployeeProfile,
} from '../model/employeeApiSchema';

export type EmployeeListParams = {
  q?: string;
  position_id?: string;
  org_unit_id?: string;
  page_token?: string;
};

/** GET /v1/employees — список сотрудников с мастер-фильтром и cursor-пагинацией. */
export async function fetchEmployees(params: EmployeeListParams = {}): Promise<EmployeeListResponse> {
  const sp = new URLSearchParams();
  if (params.q) sp.set('q', params.q);
  if (params.position_id) sp.set('position_id', params.position_id);
  if (params.org_unit_id) sp.set('org_unit_id', params.org_unit_id);
  if (params.page_token) sp.set('page_token', params.page_token);
  const qs = sp.toString();
  const json = await apiFetch<unknown>(`/employees${qs ? `?${qs}` : ''}`, { method: 'GET' });
  return employeeListResponseSchema.parse(json);
}

/** GET /v1/employees/:id — карточка сотрудника. */
export async function fetchEmployee(employeeId: string): Promise<EmployeeProfile> {
  const json = await apiFetch<unknown>(`/employees/${employeeId}`, { method: 'GET' });
  const { employee } = employeeProfileResponseSchema.parse(json);
  return employee;
}
